import { apiUrl } from "../../../setting";

export const addMainCategoryUrl = () => {
  return apiUrl + "/main-categories";
};

export const getMainCategoryUrl = () => {
  return apiUrl + "/main-categories";
};

export const deleteMainCategoryUrl = (id) => {
  return apiUrl + "/main-categories/" + id;
};

export const updateMainCategoryUrl = (id) => {
  return apiUrl + "/main-categories/" + id;
};